module.exports = __webpack_public_path__ + "media/images/sheet-input-sample-ef0b983e0babb669a5845ed40f1f1bac.png";